import FlatsPage from './flats-page';

export default class extends FlatsPage {
  constructor() {
    super();
  };

  init() {
    super.init();
  };
}
